import {RequestType, UyapRequest} from "./UyapRequest";

export class VekaletBuluBedeliTalep {

}

export interface VekaletBuluBedeliCevap {

}

export default class VekaletBuluBedeli extends UyapRequest<VekaletBuluBedeliTalep, VekaletBuluBedeliCevap> {
    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    getSpinnerMessage(){
        return "Vekalet pulu bedeli sorgulanıyor...";
    }


    cache() {
        return {
            active: false,
            ttl: (60 * 24), //* 1 gun
            key: "_"
        };
    }

    getMockResponse(): string {
        return "138"
    }

    getUrl(): string {
        return this.ImzaClientAddr + 'vekaletPuluBedeli.ajx';
    }
    getRequestType(): RequestType {
        return "json";
    }
    async parse(data: string): Promise<VekaletBuluBedeliCevap> {
        return data;
    }

}
